export default [
  {
    group: '/calendario-comites',
    model: false,
    icon: 'mdi-calendar-month-outline',
    title: 'CALENDARIO Y COMITÉS',
    meta: {
      code: 'gh-cal'
    },
    children: [
      {
        icon: 'mdi-calendar-account-outline',
        title: 'Comités Personales',
        to: 'evento',
        meta: {
          code: 'gh-cal-com_per'
        }
      },
      {
        icon: 'mdi-account-group-outline',
        title: 'Comités GH',
        to: 'comite',
        meta: {
          code: 'gh-cal-com_gh'
        }
      },
      {
        icon: 'mdi-table-account',
        title: 'Matriz de Comités',
        to: 'comite-matriz',
        meta: {
          code: 'gh-cal-mat_com'
        }
      },
      {
        icon: 'mdi-file-document-edit-outline',
        title: 'Actas de Reunión',
        to: 'compromiso',
        meta: {
          code: 'gh-cal-act_reu'
        }
      },
      {
        icon: 'mdi-folder-clock-outline',
        title: 'Proyectos',
        to: 'tarea',
        meta: {
          code: 'gh-cal-proy'
        }
      }
    ]
  },
  {
    group: '/actas',
    model: false,
    icon: 'mdi-file-document-multiple-outline',
    title: 'ACTAS',
    meta: {
      code: 'gh-act'
    },
    children: [
      {
        icon: 'mdi-view-dashboard-outline',
        title: 'Dashboard',
        to: 'dashboard',
        meta: {
          code: 'gh-act-dash'
        }
      },
      {
        icon: 'mdi-file-document-edit-outline',
        title: 'Acta de Reunión',
        to: 'actas-reunion',
        meta: {
          code: 'gh-act-act_reu'
        }
      },
      {
        icon: 'mdi-file-check-outline',
        title: 'Acta de Seguimiento',
        to: 'actas-seguimiento',
        meta: {
          code: 'gh-act-act_seg'
        }
      },
      {
        icon: 'mdi-file-search-outline',
        title: 'Matriz AAC',
        to: 'matriz-aac',
        meta: {
          code: 'gh-act-mat_aac'
        }
      },
      {
        icon: 'mdi-table-large',
        title: 'Mis Actas',
        to: 'mis-actas',
        meta: {
          code: 'gh-act-mat_aac'
        }
      }
    ]
  },
  {
    group: '/indicadores',
    model: false,
    icon: 'mdi-chart-line',
    title: 'INDICADORES DE GESTIÓN',
    meta: {
      code: 'gh-ind'
    },
    children: [
      {
        icon: 'mdi-chart-box-outline',
        title: 'Mis Indicadores',
        to: 'matriz',
        meta: {
          code: 'gh-ind-mis_ind'
        }
      },
      {
        icon: 'mdi-clipboard-text-outline',
        title: 'Hoja de Normalización',
        to: 'ficha-tecnica',
        meta: {
          code: 'gh-ind-hoj_norm'
        }
      }
    ]
  },
  {
    group: '/presupuesto',
    model: false,
    icon: 'mdi-cash-multiple',
    title: 'PRESUPUESTO',
    meta: {
      code: 'gh-pres'
    },
    children: [
      {
        icon: 'mdi-view-dashboard-outline',
        title: 'Dashboard',
        to: 'dashboard',
        meta: {
          code: 'gh-pres-dash'
        }
      },
      {
        icon: 'mdi-finance',
        title: 'Dashboard Presupuesto',
        to: 'dashboard-presupuesto',
        meta: {
          code: 'gh-pres-dashpres'
        }
      },
      {
        icon: 'mdi-cash-register',
        title: 'Registrar Presupuesto',
        to: 'registro',
        meta: {
          code: 'gh-pres-repre'
        }
      },
      {
        icon: 'mdi-sprout-outline',
        title: 'OPEX Campo',
        to: 'opex-campo',
        meta: {
          code: 'gh-pres-opex-campo'
        }
      },
      {
        icon: 'mdi-package-variant-closed',
        title: 'OPEX Packing',
        to: 'opex-packing',
        meta: {
          code: 'gh-pres-opex-pck'
        }
      },
      {
        icon: 'mdi-office-building-outline',
        title: 'OPEX Gasto Administrativo',
        to: 'opex-gasto-administrativo',
        meta: {
          code: 'gh-pres-opex-ga'
        }
      },
      {
        icon: 'mdi-laptop',
        title: 'OPEX TI',
        to: 'opex-ti',
        meta: {
          code: 'gh-pres-opex-ti'
        }
      },
      {
        icon: 'mdi-briefcase-outline',
        title: 'CAPEX',
        to: 'capex-campo',
        meta: {
          code: 'gh-pres-capex-campo'
        }
      },
      {
        icon: 'mdi-chart-bar',
        title: 'Real Observado',
        to: 'real-observado',
        meta: {
          code: '*'
        }
      },
      {
        icon: 'mdi-tag-multiple-outline',
        title: 'Tipos de Costo',
        to: 'tipos-gasto',
        meta: {
          code: 'gh-pres-tipo-costo'
        }
      },
      {
        icon: 'mdi-book-open-variant',
        title: 'Cuentas Contables',
        to: 'cuentas-contables',
        meta: {
          code: 'gh-pres-cuenta-contable'
        }
      },
      {
        icon: 'mdi-bookmark-multiple-outline',
        title: 'Cuentas Mayores',
        to: 'cuentas-mayores',
        meta: {
          code: 'gh-pres-cuenta-mayores'
        }
      },
      {
        icon: 'mdi-map-marker-radius-outline',
        title: 'Cecos',
        to: 'cecos',
        meta: {
          code: 'gh-pres-ceco'
        }
      },
      {
        icon: 'mdi-cube-outline',
        title: 'Articulos y Servicios',
        to: 'articulos-servicios',
        meta: {
          code: 'gh-pres-articulos-servicios'
        }
      },
      {
        icon: 'mdi-account-cash-outline',
        title: 'Proyección MO',
        to: 'proyeccion-mo',
        meta: {
          code: 'gh-pres-proyeccion-mo'
        }
      }
    ]
  },
  {
    group: '/proyectos',
    model: false,
    icon: 'mdi-folder-multiple-outline',
    title: 'PROYECTOS',
    meta: {
      code: 'gh-proy'
    },
    children: [
      {
        icon: 'mdi-folder-plus-outline',
        title: 'Crear Proyecto',
        to: 'registro',
        meta: {
          code: 'gh-proy-cre_proy'
        }
      },
      {
        icon: 'mdi-chart-timeline',
        title: 'Matriz de Seguimiento',
        to: 'matriz',
        meta: {
          code: 'gh-proy-mat_seg'
        }
      },
      {
        icon: 'mdi-chart-timeline',
        title: 'Mis Proyectos',
        to: 'general',
        meta: {
          code: 'gh-proy-mis_proy'
        }
      }
    ]
  },
  {
    group: '/okr',
    model: false,
    icon: 'mdi-bullseye-arrow',
    title: 'OKR',
    meta: {
      code: 'gh-okr'
    },
    children: [
      {
        icon: 'mdi-view-dashboard-outline',
        title: 'Dashboard',
        to: 'dashboard',
        meta: {
          code: 'gh-okr-dash'
        }
      },
      {
        icon: 'mdi-target',
        title: 'Crear OKR',
        to: 'metodologia-okr',
        meta: {
          code: 'gh-okr-cre_okr'
        }
      },
      {
        icon: 'mdi-timeline-check-outline',
        title: 'Matriz de Seguimiento',
        to: 'matriz-seguimiento',
        meta: {
          code: 'gh-okr-mat_seg'
        }
      },
      {
        icon: 'mdi-format-list-checks',
        title: "OKR'S",
        to: 'matriz',
        meta: {
          code: 'gh-okr-okrs'
        }
      }
    ]
  },
  {
    group: '/documentacion',
    model: false,
    icon: 'mdi-file-tree-outline',
    title: 'DOCUMENTACIÓN',
    meta: {
      code: 'gh-doc'
    },
    children: [
      {
        icon: 'mdi-folder-search-outline',
        title: 'Explorador de archivos',
        to: 'dashboard',
        meta: {
          code: 'gh-doc-expl'
        }
      }
    ]
  },
  {
    group: '/kanban',
    model: false,
    icon: 'mdi-view-dashboard-variant-outline',
    title: 'KANBAN',
    meta: {
      code: 'gh-kan'
    },
    children: [
      {
        icon: 'mdi-view-column-outline',
        title: 'Tablero',
        to: 'tablero',
        meta: {
          code: 'gh-kan-tablero'
        }
      }
    ]
  },
  {
    group: '/permisos',
    model: false,
    icon: 'mdi-shield-account-outline',
    title: 'PERMISOS',
    meta: {
      code: 'gh-perm'
    },
    children: [
      {
        icon: 'mdi-account-cog-outline',
        title: 'Usuarios',
        to: 'usuarios',
        meta: {
          code: 'gh-perm-usuario'
        }
      }
    ]
  }
];
